function initSourceLinking(){
    if ($('.frame-type-mask_ce_digitalisierung_sources-wrap').length > 0) {
        $('.frame-type-mask_ce_digitalisierung_sources-wrap .mask_ce_sources-source-elm').each(function() {
            var thisSourceID = $(this).children('span').attr('id');
            var thisSourceText = $(this).children('span').text();
            $('.content-main section .ce-content:contains("'+thisSourceText+'")').each(function () {
                $(this).html(function(_, html) {
                    var joinHTML = '<a class="source-quicklink" href="#'+ thisSourceID +'">'+ thisSourceText +'</a>';
                    return html.split(thisSourceText).join(joinHTML);
                });
            });
        });

        $('.mask_ce_sources-toggler').on('click tap', function (e) {
            if ($(this).parent().hasClass('closed') === true) {
                $(this).parent().removeClass('closed');
                $(this).siblings('.mask_ce_sources-inner-wrap').slideToggle(600);
            } else {
                $(this).siblings('.mask_ce_sources-inner-wrap').slideToggle(600, function () {
                    $(this).parent().addClass('closed');
                });
            }
        });
        $('a.source-quicklink').on('click tap', function() {
            if( $('.mask_ce_sources-outer-wrap').hasClass('closed') === true) {
                $('.mask_ce_sources-toggler').trigger('click');
            }
        });
    }
}
